import { TextField as BaseTextField, TextFieldProps } from '@wyz/ui';
import * as React from 'react';
import { useI18n } from '~/common/context';

const TextField: React.FC<TextFieldProps> = (props) => {
  const { t } = useI18n();

  return <BaseTextField {...props} translate={t} />;
};

export default TextField;
